(function () {
  'use strict';

  /* @ngdoc object
   * @name relatorios.deviceHealth
   * @description
   *
   */
  angular
    .module('relatorios.deviceHealth', [
      'ui.router',
      'restangular',
      'angularMoment',
      'FeatureFlagModule',
      'FeatureOuModule',
      'pascalprecht.translate',
      'ServiceVfiltroModule',
      'ObjetosVfiltroModule',
      'FactoryVfiltroModule',
      'ConstantVfiltroModule',
      'UrlModule'
    ]);
}());
